import { GetServerSideProps } from 'next'
import { runtimeConfig } from './runtimeConfig'

export function withRuntimeConfig(getServerSideProps?: GetServerSideProps): GetServerSideProps {
    return async (context) => {
        const serverSideProps = (await getServerSideProps?.(context)) || { props: {} }

        if ('props' in serverSideProps) {
            serverSideProps.props = {
                ...serverSideProps.props,
                runtimeConfig,
            }
        }

        return serverSideProps
    }
}
